
class UserPermissionReportAllController {
    /*@ngInject*/

    constructor(Auth, $state, User, Modal, $translate, UserBranchService, $q, UsersService, $scope) {
        this.$q = $q;
        this.UserBranchService = UserBranchService;
        this.UsersService = UsersService;
        this.Modal = Modal;
        this.$translate = $translate;
        this.$scope = $scope;

        this.model = {
            userPermissionsObj: {
                loading: false,
                totalRecords: 0,
                results: [],
            },
            userListObj: {
                loading: false,
                totalRecords: 0,
                results: [],
            },
            loggedInUser: User.getUser().id,
            branchId: User.getUser().branchId,
            userBranchList: [],
            userSubjectIds: []
        };
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.UserBranchService.getUserBranches(this.model.loggedInUser)
        ])
            .then((data) => {
                this.model.userBranchList = data[0].results;
                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.branchId) {
                        branch.ticked = true;
                    }
                })
            })
            .then(() => {
                this.getUsers().then(() => {
                    this.model.userListObj.results.filter((u) => {
                        if (u.userId == this.model.loggedInUser) {
                            u.ticked = true;
                        }
                    })
                    this.getUsersPermission();
                })
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    getUsers() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const branches = this.getSelectedBranches();
                this.model.userListObj.loading = true;
                this.UsersService.userList(branches)
                    .then((data) => {
                        this.model.userListObj.results = data.results;
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
                    .finally(() => {
                        this.model.userListObj.loading = false;
                        resolve();
                    })
            });
        })
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    getSelectedUsers() {
        return Array.isArray(this.model.selectedUsers) ? this.model.selectedUsers.map((user) => user) : null;
    }

    getUsersPermission() {
        setTimeout(() => {
            const branches = this.getSelectedBranches();
            const users = this.getSelectedUsers();
            const indexMap = {}, finalResults = [];

            branches.forEach((branch) => {
                users.forEach((user) => {
                    if (!indexMap.hasOwnProperty(user.userId)) {
                        indexMap[user.userId] = finalResults.length;
                        finalResults.push({ userId: user.userId, userName: user.userName, branches: [] });
                    }

                    const { branches } = finalResults[indexMap[user.userId]];
                    branches.push(branch);
                })
            })

            this.model.userPermissionsObj.loading = true;
            this.UsersService.userPermissions(finalResults)
                .then((data) => {
                    this.model.userPermissionsObj.results = data.results;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.userPermissionsObj.loading = false;
                })
        });
    }

    translateHeader(key) {
        if (!key) return;

        if (key === 'other') return 'Other';
        else if (key === 'setting') return this.$translate.instant('common.side_menu.settings');
        else if (key === 'price_point') return this.$translate.instant('price_point.price_point');
        else if (key === 'scheduled_shipment') return this.$translate.instant('scheduled_shipment.title');
        return this.$translate.instant(`common.side_menu.${key}`);
    }

    iconMap(key) {
        if (!key) return;

        const icon = {
            'branch_mgmt': 'glyphicon glyphicon-map-marker',
            'fuel_surcharges': 'glyphicon glyphicon-usd',
            'other': 'glyphicon glyphicon-info-sign',
            'setting': 'glyphicon glyphicon-cog',
            'tnt_billing': 'glyphicon glyphicon-calendar',
            'tnt_control': 'glyphicon glyphicon-asterisk',
            'price_point': 'glyphicon glyphicon-usd'
        }
        return icon[key];
    }

    generateUniqueId(branchId, userId, key) {
        if (!branchId || !key || !userId) return;
        const branch = branchId.replace(/\s/g, "-");
        return `${branch}_${userId}_${key}`;
    }

    translatePageName(key) {
        const commonKeys = ['fuel_surcharges', 'route_throw', 'bag_out', 'route_sheet', 'bulk_cash_management', 'atm_count', 'coin_pull_report',
            'check_out', 'check_in', 'shipment_batch', 'route_progress', 'master_cash_schedule', 'service_tickets', 'route_stats',
            'vault_operations', 'master_cash_schedule', 'deposit_packing', 'vault_close', 'route_control', 'order_packing',
            'tnt_billing', 'tnt_control'];

        const branchMgmtKeys = ['tankers', 'restore_route_assignments', 'location_holds', 'final_residual_count_commit', 'monthly_report', 'deleted_shipments',
            'tnt_bypass_code', 'physical_cash_count', 'customer_pickup_reports', 'lock_open_errors', 'items', 'daily_balance_sheet', 'stop_performance',
            'cash_transactions', 'orders', 'bypass_code', 'bagouts', 'billing_approval', 'routes', 'count_variances', 'branch_performance',
            'cancelled_shipments', 'item_holds'];

        const mapping = {
            contract: this.$translate.instant('contract.contract'),
            customer: this.$translate.instant('customer.contact'),
            billable_events: this.$translate.instant('billableEvents.menu.title'),
            billing_category: this.$translate.instant('billableEvents.billing_category'),
            mobile_app: this.$translate.instant('mobileApp.menu.title'),
            shiptype: this.$translate.instant('denomination.shiptype'),
            user_permission_report: this.$translate.instant('userPermissionReport.menu.title'),
            branch_setup: this.$translate.instant('branch_setup.menu.title'),
            denomination: this.$translate.instant('transaction_log.denomination'),
            message: this.$translate.instant('common.message'),
            locations: this.$translate.instant('fuel_surcharge.locations'),
            'setting-service-ticket-parts': this.$translate.instant('serviceTicketParts.menu.title'),
            'setting-truck': this.$translate.instant('branch_mgmt.route_truck'),
            'setting-routes': this.$translate.instant('branch_mgmt.routes.title'),
            'setting-batch': this.$translate.instant('addBagModal.batch'),
            'setting-location': this.$translate.instant('fuel_surcharge.locations'),
            'setting-branch': this.$translate.instant('bagout.branch'),
            'setting-setup': this.$translate.instant('common.side_menu.setup'),
            'setting-branch-funding-source-holiday': this.$translate.instant('branchFundingSourceHoliday.menu.title'),
            'setting-holiday': this.$translate.instant('holiday.menu.title'),
            'setting-items': this.$translate.instant('item.items'),
            'setting-branch-funding-source': this.$translate.instant('branchFundingSource.menu.title'),
            'setting-carrier': this.$translate.instant('addBagModal.carrier'),
            'environment-config': this.$translate.instant('environment_config.menu.title'),
            'setting-service-settings': this.$translate.instant('serviceSettings.menu.title'),
            'setting-log': this.$translate.instant('log.menu.title'),
            'setting-service-checklist': this.$translate.instant('serviceSettings.checklist.title'),
            'setting-users': this.$translate.instant('users.menu.title'),
            'setting-reset-atm-code': this.$translate.instant('resetAtmCode.menu.title'),
            'setting-delivery-region-routing': this.$translate.instant('deliveryRegionRouting.menu.title'),
            price_point: this.$translate.instant('price_point.price_point'),
            scheduled_shipment: this.$translate.instant('scheduled_shipment.title'),
            atm_codes_management: this.$translate.instant('navbar.atm_codes_management'),
        };

        if (commonKeys.includes(key)) return this.$translate.instant(`common.side_menu.${key}`);
        else if (branchMgmtKeys.includes(key)) return this.$translate.instant(`branch_mgmt.${key}.title`);
        else if (!mapping[key]) return key;

        return mapping[key];
    }

    resetData() {
        this.model.userPermissionsObj.results = [];
    }

    getTooltip(key) {
        if (!key) return;
        key = key.charAt(0).toUpperCase() + key.slice(1);
        return this.$translate.instant(`common.${key}`);
    }

    userPermissionReport() {
        setTimeout(() => {
            const branches = this.getSelectedBranches(), 
                  users = this.getSelectedUsers(), 
                  finalResults = [],
                  reportPrefix = 'User_Permission_Report';

            branches.forEach((branch) => {
                users.forEach((user) => {
                    finalResults.push({ branchId: branch, userId: user.userId, userSubjectId: 'user:' + user.userId + branch, 
                                        userName: user.userName});
                })
            })

            this.model.isExporting = true;
            this.UsersService.userPermissionReport(finalResults)
                .then((data) => {
                    this.downloadFile(reportPrefix, data.reportData)
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message)
                    }
                })
                .finally(() => {
                    this.model.isExporting = false;
                })
        });
    }


    downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
    }
}

export default UserPermissionReportAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/user_permission_report/all/user_permission_report.all.controller.js